import { render, staticRenderFns } from "./throneOfHeaven.vue?vue&type=template&id=d4587808&"
import script from "./throneOfHeaven.vue?vue&type=script&lang=js&"
export * from "./throneOfHeaven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports